// src/pages/cpaCareerQuiz/components/ResultPage.jsx
import { motion } from "framer-motion";
import { CAREERS } from "../data/constants";
import { RESULT_TEMPLATES } from "../data/resultTemplates";
import LeadGenSection from "./LeadGenSection";
import ShareCTA from "./ShareCTA";

export default function ResultPage({ result, onRestart }) {
  const tpl = RESULT_TEMPLATES[result.careerKey];

  return (
    <>
    {tpl?.image && (
        <div className="result-image-wrap">
          <img
            className="result-image"
            src={tpl.image}
            alt={tpl?.badgeTitle || CAREERS[result.careerKey]}
          />
        </div>
      )}
    <motion.fieldset
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.6 }}
    >
      <div className="title">
        <h2>測驗結果</h2>
        <p>你的最適配職涯路徑如下</p>
      </div>
      
      <div className="result-card">
        <div className="result-badge">{tpl?.badgeTitle || CAREERS[result.careerKey]}</div>
        <h3 className="mt-3">{tpl?.title}</h3>

        <div className="mt-3">
          <b>契合度：</b> {result.percentage}%（{result.range}）
          <div className="text-muted mt-1">{result.fitLabel}</div>
        </div>

        <hr />

        <b>特質描述</b>
        <div className=" mb-5">{tpl?.trait}</div>

        <b>為什麼適合你</b>
        <div className=" mb-5">{tpl?.why}</div>

        <b>在台灣的職涯</b>
        <div className=" mb-5">{tpl?.tw}</div>

        <b>在國際上的職涯</b>
        <div className=" mb-5">{tpl?.global}</div>

        <b>Becker 建議</b>
        <div className=" mb-5">{tpl?.becker}</div>
      </div>

      <LeadGenSection />
      {tpl?.image && (
        <div className="result-image-wrap mt-2">
          <img
            className="result-image"
            src={tpl.image}
            alt={tpl?.badgeTitle || CAREERS[result.careerKey]}
          />
        </div>
      )}
      <div className="hint">手機長按圖片即可下載，可分享給好友</div>
      <ShareCTA result={result} />
      

      <div className="action-buttons mt-5 mb-5 m-auto">
        <button type="button" className="action-button previous_button" onClick={onRestart}>
          重新測一次
        </button>
      </div>
    </motion.fieldset>
    </>
  );
}
